export const PUBLIC_DOMAIN = "homealarmreport.com"
export const TEST_DOMAIN = "localhost"
export const GRAPH_URL = "https://api.homealarmreport.com/allGraphql"
// export const GRAPH_URL = "http://localhost:4400/allGraphql"
